import { ViewId } from "@msidentity/SISU/constants";
import { useTriggerChallenge } from "@msidentity/SISU/views/challenge/hooks/use-trigger-challenge";
import { useValidateChallenge } from "@msidentity/SISU/views/challenge/hooks/use-validate-challenge";
import { type SendOttRequest, sendOtt } from "../../../../../../utilities/api-helpers";
import { getSendOttParams } from "../../../../model/get-send-ott-params";
import { useSendOttSuccessHandler } from "../../../../model/hooks/use-send-ott";
import { useSendOttFailureHandler } from "../../../../model/hooks/use-send-ott-failure-handler";
import { type IUsernameRecoveryConfig } from "../../../../username-recovery-config";
import { useUsernameRecoveryContext } from "../../../../username-recovery-context";

const viewId = ViewId.Challenge;

/**
 * Hook to handle the challenge view properties
 * @param config - username recovery config
 * @returns challenge view properties
 */
export const useUsernameRecoveryChallenge = function useUsernameRecoveryChallenge(
  config: IUsernameRecoveryConfig,
) {
  const {
    sendCodeInfo: { sendOttAction, sendOttUrl },
  } = config;
  const {
    viewState: { usernameType, usernameVal, phoneCountryState },
  } = useUsernameRecoveryContext();

  const successHandler = useSendOttSuccessHandler({
    viewId,
    proofId: usernameVal,
    phoneCountry: phoneCountryState,
    memberNameType: usernameType,
  });
  const failureHandler = useSendOttFailureHandler(viewId);
  const triggerChallenge = useTriggerChallenge();
  const sendOttParams: SendOttRequest = getSendOttParams(
    sendOttAction,
    usernameType,
    phoneCountryState,
    usernameVal,
  );

  const validateChallenge = useValidateChallenge({
    requestHandler: sendOtt,
    validationSuccessHandler: successHandler,
    validationErrorHandler: triggerChallenge,
    handoverErrorHandler: failureHandler,
    url: sendOttUrl,
    flowRequestParams: sendOttParams,
  });

  return validateChallenge;
};
